import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const loginUser = async (email, password) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/login`, { email, password });
        console.log("Login response:", response.data);

        if (response.data && response.data.user) {
            return {
                success: true,
                data: {
                    ...response.data.user,
                    token: response.data.token || '',
                    package_type: response.data.user.package_type || 'basic'
                },
            };
        }

        throw new Error('Invalid response format');
    } catch (error) {
        console.error(error.response?.data);
        return {
            success: false,
            error: error.response?.data?.error || "Login failed",
        };
    }
};
